import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'whitespaceToUnderscore',
    standalone: false
})
export class WhitespaceToUnderscorePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      return value.replace(/ /g, '_');
    }
  }
}
